import Axios from "axios";
import _ from "lodash";
import React, { useMemo, useState } from "react";
import AddTeacherModal from "./AddTeacherModal/AddTeacherModal";
import AdminTeacherCard from "./AdminTeacherCard/AdminTeacherCard";
import AdminTeacherModal from "./AdminTeacherModal/AdminTeacherModal";
import ViewTimesheet from "./CreateTimesheet/ViewTimesheet/ViewTimesheet";
import NewLoadingScreen from "./NewLoadingScreen/NewLoadingScreen";
import SearchHeader from "./SearchHeader/SearchHeader";
import { FilterTypeId } from "./SearchHeader/filters-type";
import { baseUrl } from "./assets/Animations";
import loadingping from "./img/loadingpin.svg";
import { getRequestHeaders } from "./api";
import {
  matchesTeacherStatusFilters,
  TEACHER_STATUS_OPTIONS,
} from "./teacherDatabaseFilters";

const normalizeTownValue = (value) =>
  value == null ? "" : String(value).trim().toLowerCase();

const normalizeSearchValue = (value) =>
  value == null ? "" : String(value).trim().toLowerCase();

const AdminDashboard = (props) => {
  const [teachers, setTeachers] = useState([]);
  const [filteredTeachers, setFilteredTeachers] = useState([]);
  const [teachersToDisplay, setTeachersToDisplay] = useState([]);
  const [teacherModal, setTeacherModal] = useState(false);
  const [wholeAvail, setWholeAvail] = useState([]);
  const [nameQuery, setNameQuery] = useState("");
  // const [instQuery, setInstQuery] = useState("");
  // const [schoolQuery, setSchoolQuery] = useState("");
  // const [statusQuery, setStatusQuery] = useState("");
  // const [dateQuery, setDateQuery] = useState("Everyday");
  // const [fullQuery, setFullQuery] = useState("Available");
  const [filterState, setFilterState] = useState({});
  //   const [background, setBackground] = useState("background-1.jpg");
  const [addTeacherModal, setAddTeacherModal] = useState(false);
  const [lineView, setLineView] = useState(false);
  const [studentModal, setStudentModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSVG, setLoadingSVG] = useState(false);
  const [openTimesheet, setOpenTimesheet] = useState(false);
  const [timesheets, setTimesheets] = useState([]);
  const [schools, setSchools] = useState([]);

  const isManager = props.userData.PermissionLevel === "manager" && props.userData.IsAdmin;

  const normalizeTeacher = (teacher) => {
    if (!teacher || typeof teacher !== "object") {
      return null;
    }

    return {
      ...teacher,
      InstrumentList: Array.isArray(teacher.InstrumentList) ? teacher.InstrumentList : [],
      AvailabilityDetails:
        teacher.AvailabilityDetails && typeof teacher.AvailabilityDetails === "object"
          ? teacher.AvailabilityDetails
          : {},
      newStudentList: Array.isArray(teacher.newStudentList) ? teacher.newStudentList : [],
    };
  };

  React.useEffect(() => {
    setLoadingSVG(true);
    loadTeacherDatabase();
    getTimesheets();
    getSchoolFilterOptions()
  }, []);

  React.useEffect(() => {
    filterTeachers();
  }, [teachers]);

  React.useEffect(() => {
    if (teacherModal && !props.studentModal2022) {
      setTimeout(() => {
        props.getNotesAboutModal(
          teacherModal.TeacherID,
          "teacherId",
          teacherModal.Name
        );
      }, 300);
    }
  }, [teacherModal, props.studentModal2022]);

  React.useEffect(() => {
    if (teacherModal && teacherModal.TeacherID) {
      updateOpenTeacherModal();
    }
  }, [filteredTeachers]);

  React.useEffect(() => {
    filterTeachers();
    changeBackgroundImageBySchool();
  }, [nameQuery, filterState]);

  const loadTeacherDatabase = async () => {
    try {
      setLoadingSVG(true);

      const activeRes = await Axios.get(
        `${baseUrl}/teacher-database-active`,
        getRequestHeaders()
      );

      const activeTeachers = (Array.isArray(activeRes.data) ? activeRes.data : [])
        .map(normalizeTeacher)
        .filter(Boolean);
      const sortedActiveTeachers = sortByStudent([...activeTeachers]);

      setTeachers(sortedActiveTeachers);
      setFilteredTeachers(sortedActiveTeachers);
      setTeachersToDisplay(sortedActiveTeachers);
      setLoadingSVG(false);

      const leftRes = await Axios.get(
        `${baseUrl}/teacher-database-left`,
        getRequestHeaders()
      );

      const leftTeachers = (Array.isArray(leftRes.data) ? leftRes.data : [])
        .map(normalizeTeacher)
        .filter(Boolean);

      setTeachers((prev) => sortByStudent([...prev, ...leftTeachers]));
    } catch (err) {
      console.log(err);
      setLoadingSVG(false);
    }
  };

  const getTimesheets = () => {
    Axios.get(`${baseUrl}/getalltimesheetsendpoint`)
      .then((response) => {
        setTimesheets(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const changeBackgroundImageBySchool = () => {
    // if (schoolQuery === "mma") {
    //   setBackground("MMA.jpg");
    // } else if (schoolQuery === "lsma") {
    //   setBackground("LMA.jpg");
    // } else if (schoolQuery === "tma") {
    //   setBackground("TMA.jpg");
    // } else if (schoolQuery === "glma") {
    //   setBackground("GLMA.jpg");
    // } else {
    //   setBackground("background-1.jpg");
    // }
  };

  const sortByStudent = (list) => {
    let sortedFinalList = list.sort((a, b) => {
      return (b.newStudentList?.length || 0) - (a.newStudentList?.length || 0);
    });
    return sortedFinalList;
  };

  const filterTeachers = () => {
    const masterList = teachers.filter((teacher) => {
      // Name
      const nameFilter = normalizeSearchValue(nameQuery);
      const searchTerms = nameFilter.split(/\s+/).filter(Boolean);
      const searchableFields = [
        teacher.Name,
        teacher.School,
        teacher.Status,
        teacher.Email,
        ...(Array.isArray(teacher.InstrumentList)
          ? teacher.InstrumentList.flatMap((instrument) => [
              instrument?.name,
              instrument?.parentInstrument,
              instrument?.instrument,
              instrument?.instrumentGroup,
            ])
          : []),
        ...(Array.isArray(teacher.TownList)
          ? teacher.TownList.flatMap((town) => [town?.townName, town?.id])
          : []),
      ]
        .map(normalizeSearchValue)
        .filter(Boolean);

      const nameMatch =
        searchTerms.length === 0 ||
        searchTerms.every((term) =>
          searchableFields.some((value) => value.includes(term))
        );
      // Schools
      const selectedSchools = isManager ? [props.userData.School] : filterState.school;
      const schoolMatch =
        !selectedSchools ||
        selectedSchools.length === 0 ||
        selectedSchools.includes(teacher.School);
      // Instruments
      const selectedInstruments = filterState.instrument;
      const instrumentMatch =
        !selectedInstruments ||
        selectedInstruments.length === 0 ||
        selectedInstruments.every((instrumentId) =>
          teacher.InstrumentList.some((instrument) => instrument.id === instrumentId)
        );
      // Towns
      const selectedTowns = filterState.town;
      const townMatch =
        !selectedTowns ||
        selectedTowns.length === 0 ||
        (Array.isArray(teacher.TownList) &&
          selectedTowns.every((selectedTown) =>
            teacher.TownList.some((town) => {
              const normalizedSelectedTown = normalizeTownValue(selectedTown);
              return (
                normalizeTownValue(town?.id) === normalizedSelectedTown ||
                normalizeTownValue(town?.townName) === normalizedSelectedTown
              );
            })
          ));
      // Days
      const selectedDays = filterState.days;
      const dayMatch = !selectedDays || selectedDays.length === 0 || 
        ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].some(day => 
          teacher.AvailabilityDetails[day]?.length > 0 && selectedDays.includes(day) && teacher.WantsMoreStudents && teacher.Status !== "goon" && teacher.Status !== "summer-break" && teacher.Status !== "leaving" && teacher.Status !== "Left School"
        );

      const statusMatch = matchesTeacherStatusFilters(
        teacher,
        filterState.status,
        filterState.leftSchool
      );
      return nameMatch && instrumentMatch && townMatch && statusMatch && schoolMatch && dayMatch;
    });

    const sortedTeachers = sortByStudent([...masterList]);
    setFilteredTeachers(sortedTeachers);
    setTeachersToDisplay(sortedTeachers);
  };

  const openNewTeacher = () => {
    setAddTeacherModal((prevState) => !prevState);
  };
  const closeNewTeacherModal = (teacherInfo) => {
    let addATeacher = teachers;
    addATeacher.push(teacherInfo);
    setTeachers([...addATeacher]);
    setAddTeacherModal(false);
  };

  const removeDeletedTeacher = (TeacherID) => {
    for (let i = 0; i < teachers.length; i++) {
      if (teachers[i].TeacherID === TeacherID) {
        teachers.splice(i, 1);
        setTeachers([...teachers]);
      }
    }
  };

  const massCheck = (isChecked) => {
    let theBoxes = document.getElementsByClassName("student-checkbox");
    if (isChecked) {
      for (let i = 0; i < theBoxes.length; i++) {
        theBoxes[i].checked = true;
      }
    } else {
      for (let i = 0; i < theBoxes.length; i++) {
        theBoxes[i].checked = false;
      }
    }
  };

  const copyAttempt = () => {
    let theList = "";
    let theBoxes = document.getElementsByClassName("student-checkbox");
    for (let i = 0; i < theBoxes.length; i++) {
      if (theBoxes[i].checked === true) {
        theList = theList + " " + theBoxes[i].value + ";";
      }
    }
    navigator.clipboard.writeText(theList);
    setTimeout(function () {
      alert("Emails have been copied to you clipboard");
    }, 0);
  };
  const openStudentModal = async (familyId) => {
    setLoading("Getting Student");
    Axios.get(`${baseUrl}/school-management/${familyId}`)
      .then((res) => {
        setStudentModal(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const updateOpenTeacherModal = () => {
    if (!teacherModal || !teacherModal.TeacherID) {
      return;
    }
    let updatedTeacherModal = teacherModal;
    for (let i = 0; i < teachers.length; i++) {
      if (teacherModal.TeacherID === teachers[i].TeacherID) {
        updatedTeacherModal.newStudentList = teachers[i].newStudentList;
        setTeacherModal(updatedTeacherModal);
      }
    }
  };
  const closeStudentModal = (msg, family) => {
    setStudentModal(false);
    loadTeacherDatabase();
  };
  const closeTeacherModal = (teacherData) => {
    //setModal(false)
    setTeacherModal(false);
    //props.setShowNotes(false)
    props.closeSideNotesWithAnimation();
    let updatedTeacherList = teachers;
    let updatedFilteredTeacherList = filteredTeachers;
    for (let i = 0; i < updatedTeacherList.length; i++) {
      if (updatedTeacherList[i].TeacherID === teacherData.TeacherID) {
        updatedTeacherList[i] = teacherData;
        setTeachers([...updatedTeacherList]);
      }
    }
    for (let i = 0; i < updatedFilteredTeacherList.length; i++) {
      if (updatedFilteredTeacherList[i].TeacherID === teacherData.TeacherID) {
        updatedFilteredTeacherList[i] = teacherData;
        setFilteredTeachers([...updatedFilteredTeacherList]);
      }
    }
  };

  const getSchoolFilterOptions = async () => {
    let schoolOptions = [];
    Axios.get(`${baseUrl}/schools`)
    .then((res) => {
      res.data.forEach(school => {
        schoolOptions.push({ id: school.schoolAbbreviation.toLocaleLowerCase(), label: school.name.split(' ')[0] });
      })
    })
    .catch((err) => {
      console.log(err);
    })
    setSchools(schoolOptions);
  }

  const filters = useMemo(
    () => [
      {
        id: "status",
        label: "Status",
        type: FilterTypeId.Dropdown,
        options: TEACHER_STATUS_OPTIONS,
      },
      {
        id: "leftSchool",
        label: "Show Left School",
        type: FilterTypeId.Switch,
      },
      {
        id: "days",
        label: "Days",
        type: FilterTypeId.Dropdown,
        options: [
          { id: "Monday", label: "Mondays" },
          { id: "Tuesday", label: "Tuesdays" },
          { id: "Wednesday", label: "Wednesdays" },
          { id: "Thursday", label: "Thursdays" },
          { id: "Friday", label: "Fridays" },
          { id: "Saturday", label: "Saturdays" },
          { id: "Sunday", label: "Sundays" },
        ],
      },
      {
        id: "instrument",
        label: "Instrument",
        type: FilterTypeId.Dropdown,
        options:
          teachers &&
          _.uniqBy(
            teachers.reduce((acc, teacher) => {
              return [
                ...acc,
                ...teacher.InstrumentList.map((instrument) => {
                  return {
                    id: instrument.id,
                    label: instrument.name,
                    group: instrument.instrumentGroup,
                  };
                }),
              ];
            }, []),
            (x) => x.id
          ),
      },
      {
        id: "town",
        label: "Town",
        type: FilterTypeId.Dropdown,
        options: [
          { id: "duluth", label: "Duluth" },
        ],
      },
      !isManager && {
        id: "school",
        label: "School",
        type: FilterTypeId.Dropdown,
        options: schools,
      },
    ],
    [isManager, schools, teachers]
  );

  const skeletonCards = Array.from({ length: 12 }, (_, index) => (
    <div key={`teacher-skeleton-${index}`} className="admin-teacher-card admin-teacher-card--skeleton">
      <div className="admin-teacher-card-pic admin-teacher-card-skeleton-block admin-teacher-card-skeleton-photo" />
      <div className="admin-teacher-card-skeleton-name-wrap">
        <div className="admin-teacher-card-skeleton-block admin-teacher-card-skeleton-name" />
        <div className="admin-teacher-card-skeleton-block admin-teacher-card-skeleton-name admin-teacher-card-skeleton-name--short" />
      </div>
      <div className="admin-teacher-card-skeleton-badges">
        <div className="admin-teacher-card-skeleton-block admin-teacher-card-skeleton-badge" />
        <div className="admin-teacher-card-skeleton-block admin-teacher-card-skeleton-badge" />
      </div>
    </div>
  ));

  return (
    <div
    //   style={{
    //     backgroundImage:
    //       "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(" +
    //       background +
    //       ")",
    //   }}
    >
      {loading && <NewLoadingScreen message={loading} />}
      {teacherModal && (
        <AdminTeacherModal
          openStudentModal={openStudentModal}
          closeModal={closeTeacherModal}
          wholeAvail={wholeAvail}
          teacher={teacherModal}
          removeDeletedTeacher={removeDeletedTeacher}
          setOpenTimesheet={setOpenTimesheet}
          getFamilyData={props.getFamilyData}
          setStudentModal2023={props.setStudentModal2023}
        />
      )}
      <AddTeacherModal
        open={addTeacherModal}
        closeModal={closeNewTeacherModal}
        setAddTeacherModal={setAddTeacherModal}
      />
      {openTimesheet && (
        <ViewTimesheet
          setOpenTimesheet={setOpenTimesheet}
          openTimesheet={openTimesheet}
        />
      )}
      <SearchHeader
        title="Teacher Database"
        cta="New Teacher"
        onChangeQuery={(string) => setNameQuery(string)}
        onChangeFilters={(filterState) => setFilterState(filterState)}
        onClickCta={openNewTeacher}
        filters={filters}
        clearAll={true}
        searchInputBasis="360px"
      />
      <div className="admin-dashboard-box">
        {!lineView && (
          <div className="admin-teacher-card-wrapper">
            {loadingSVG && teachersToDisplay.length === 0 && skeletonCards}
            {loadingSVG && teachersToDisplay.length > 0 && <img className="loading-ping" src={loadingping} />}
            {!loadingSVG && teachersToDisplay.map((teacher, index) => (
              <AdminTeacherCard
                key={`${teacher.TeacherID ?? "teacher"}-${teacher.Email ?? index}`}
                id={`teacher-card-${teacher.TeacherID}`}
                teacherStatus={teacher.Status}
                openModal={(teacher) => setTeacherModal(teacher)}
                teacher={teacher}
                timesheets={timesheets}
              />
            ))}
          </div>
        )}
        {lineView && (
          <div className="the-table-wrapper">
            <div className="student-db-btn-wrapper">
              <div className="add-email-btn" onClick={() => copyAttempt()}>
                COPY EMAILS
              </div>
            </div>
            <table className="student-table">
              <thead>
                <tr>
                  <th>
                    <input
                      onClick={(e) => massCheck(e.target.checked)}
                      type="checkbox"
                    />
                  </th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Students</th>
                  <th>School</th>
                  <th>Status</th>
                </tr>
              </thead>
              {teachersToDisplay.length > 0 ? (
                <tbody>
                  {teachersToDisplay.map((teacher) => (
                    <tr key={teacher.TeacherID} className="each-row">
                      <td>
                        <input
                          className={"student-checkbox"}
                          type="checkbox"
                          value={teacher.Email}
                        />
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.Name}
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.Email}
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.PhoneNumber}
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.newStudentList.length}
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.School}
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.newStudentList.length > 0
                          ? "Active"
                          : "Waiting"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <div className="admin-tasks-loading-text">
                    Getting teachers...
                  </div>
                </tbody>
              )}
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
